module.exports = __webpack_public_path__ + "media/images/icons/bell-icon-e5df959a766b164538fc7953ee577f08.svg";